var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Link"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0808 6.91205C13.4062 7.23748 13.4062 7.76512 13.0808 8.09056L8.08079 13.0906C7.75536 13.416 7.22772 13.416 6.90228 13.0906C6.57684 12.7651 6.57684 12.2375 6.90228 11.912L11.9023 6.91205C12.2277 6.58661 12.7554 6.58661 13.0808 6.91205Z",
    fill: "#454551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.155 5.12265L9.79015 5.545C9.4893 5.89329 8.96306 5.93174 8.61477 5.63089C8.26649 5.33003 8.22803 4.8038 8.52889 4.45551L8.91472 4.00884C8.92798 3.99349 8.94179 3.97863 8.95614 3.96429C9.89393 3.02663 11.1658 2.49991 12.492 2.5C13.8181 2.50009 15.0899 3.02699 16.0276 3.96479C16.9652 4.90259 17.492 6.17446 17.4919 7.50061C17.4918 8.82676 16.9649 10.0986 16.0271 11.0362C16.0133 11.05 15.9991 11.0632 15.9844 11.076L15.5394 11.4626C15.192 11.7645 14.6657 11.7276 14.3638 11.3802C14.0619 11.0328 14.0989 10.5064 14.4463 10.2045L14.868 9.83807C15.4811 9.21488 15.8251 8.37543 15.8252 7.50049C15.8253 6.61637 15.4741 5.76843 14.849 5.14322C14.2238 4.51801 13.376 4.16673 12.4918 4.16667C11.6173 4.1666 10.7782 4.51019 10.155 5.12265Z",
    fill: "#454551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.61679 8.61359C5.92153 8.95848 5.88898 9.48511 5.54409 9.78986L5.12593 10.1593C4.82196 10.4639 4.58025 10.8249 4.4144 11.2222C4.24571 11.6262 4.15885 12.0596 4.15885 12.4975C4.15885 12.9353 4.24571 13.3687 4.4144 13.7728C4.58308 14.1768 4.83024 14.5433 5.14156 14.8511L5.14159 14.8512C5.77621 15.4787 6.63271 15.8307 7.52522 15.8307C8.39775 15.8307 9.23587 15.4943 9.86591 14.8929L10.1569 14.5015C10.4315 14.1322 10.9535 14.0554 11.3228 14.3299C11.6922 14.6045 11.769 15.1265 11.4944 15.4959L11.1636 15.9409C11.1384 15.9747 11.1107 16.0066 11.0808 16.0363C10.1341 16.9723 8.85653 17.4974 7.52522 17.4974C6.19393 17.4974 4.91634 16.9724 3.96971 16.0363C3.50163 15.5734 3.13002 15.0223 2.8764 14.4149C2.62278 13.8075 2.49219 13.1557 2.49219 12.4975C2.49219 11.8392 2.62278 11.1875 2.8764 10.58C3.13002 9.97257 3.50163 9.42147 3.96971 8.95864C3.98079 8.94768 3.99218 8.93704 4.00385 8.92673L4.44052 8.54089C4.78541 8.23615 5.31205 8.2687 5.61679 8.61359Z",
    fill: "#454551"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/Link.335b91097c63f1aa8c82ec2925ea1429.svg";
export { ForwardRef as ReactComponent };